import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { AppConstants } from "../../app.constants";
import { Observable, of } from "rxjs";
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ErrorHandlerService } from "src/app/core/services/error-handler.service";

@Injectable({
  providedIn: 'root'
})
export class RightsWiseLoginService {

  constructor(private http: HttpClient, private router: Router, private errorHandlerService: ErrorHandlerService) { }

  registerUser(formData: any, email: string): Observable<any> {
    const data = { ...formData, user_email: email };
    return this.http.post(`${AppConstants.API_ENDPOINT1}${AppConstants.API.REGISTER_USER.USER_ACSESS}`, data).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

  getUsers(email): Observable<any> {
    const params = new HttpParams()
      .set('user_email', email.toString());
    return this.http.get(
      `${AppConstants.API_ENDPOINT}${AppConstants.API.REGISTER_USER.GET_USERS}`, { params }
    ).pipe(catchError((error) => this.errorHandlerService.handleError(error)));;
  }

  deleteUser(id: string, email: string): Observable<any> {
    const payload = { id, email };
    return this.http.post(`${AppConstants.API_ENDPOINT1}${AppConstants.API.REGISTER_USER.DELETE_USER}`, payload).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

  updateUser(updateData: any): Observable<any> {
    return this.http.post(`${AppConstants.API_ENDPOINT1}${AppConstants.API.REGISTER_USER.UPDATE_USER}`, updateData).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

}
